import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import agencyMetricsType from "../AgencyPerformanceMetrics/types/agencyMetricsType";
import {
  Wrapper,
  Header,
  Body,
  Row,
  Column,
  Number,
  Description,
  InfoDot,
} from "./styles/agency-pipeline-metrics-styles";

interface IAgencyPipelineMetricsTypes {
  pipeline: {
    interviews: number;
    interviewsCount: number;
    engagements: number;
    engagementsCount: number;
    currency: {
      symbol: string;
      isoCode: string;
    };
  };
}

interface IAgencyPipelineMetricsProps {
  loading: boolean;
  agencyMetrics: IAgencyPipelineMetricsTypes;
}

export const AgencyPipelineMetrics: FunctionComponent<
  IAgencyPipelineMetricsProps
> = ({ loading, agencyMetrics }) => {
  const interviewsTooltip =
    "Potential earnings from your <br /> current engagements at interview";
  const engagementsTooltip =
    "Potential earnings from your <br /> current active engagements";

  const currencySymbol = agencyMetrics
    ? agencyMetrics.pipeline.currency.symbol
    : "";

  return (
    <Wrapper>
      {loading && <WidgetLoading zIndex={1} />}
      <Header className="panel-heading">
        <div className="panel-title">Estimated Pipeline</div>
      </Header>
      <Body>
        <ReactTooltip
          html
          place="bottom"
          type="dark"
          effect="float"
          aria-haspopup="true"
          id="pipeline-tooltip"
        />
        <Row>
          <Column
            flex={1}
            data-tip={interviewsTooltip}
            data-for="pipeline-tooltip"
          >
            <Number fontSize="large" data-test-id="interviews">
              {currencySymbol}
              {agencyMetrics && Math.round(agencyMetrics.pipeline.interviews)}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description data-test-id="interviews-count">
              From {agencyMetrics && Math.round(agencyMetrics.pipeline.interviewsCount)}{" "}
              Engagements at Interview
            </Description>
          </Column>
          <Column
            flex={1}
            data-tip={engagementsTooltip}
            data-for="pipeline-tooltip"
          >
            <Number fontSize="large" data-test-id="engagements">
              {currencySymbol}
              {agencyMetrics && agencyMetrics.pipeline.engagements}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description data-test-id="engagements-count">
              From {agencyMetrics && agencyMetrics.pipeline.engagementsCount}{" "}
              Engagements
            </Description>
          </Column>
        </Row>
      </Body>
    </Wrapper>
  );
};

AgencyPipelineMetrics.propTypes = {
  loading: PropTypes.bool.isRequired,
  agencyMetrics: agencyMetricsType,
};

AgencyPipelineMetrics.defaultProps = {
  agencyMetrics: null,
};

interface IReduxState {
  dashboard: {
    loading: boolean;
    agencyMetrics: IAgencyPipelineMetricsTypes;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.dashboard.loading,
  agencyMetrics: state.dashboard.agencyMetrics,
});

export default connect(mapStateToProps, {})(AgencyPipelineMetrics);
